module.exports = __webpack_public_path__ + "static/media/finance.663d0af9.png";